import { Link } from "react-router-dom";
import { Shield, MapPin, Phone, Mail, Facebook, Instagram, Youtube } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#0F172A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_volpiano-calcio/artifacts/8nz2bql1_IMG_8381.webp" 
                alt="G.S.D. Volpiano Pianese"
                className="h-14 w-auto bg-white rounded-lg p-1"
              />
              <div>
                <span className="font-bold text-xl tracking-tight">VOLPIANOPIANESE</span>
                <span className="block text-sm font-medium text-slate-400">G.S.D.</span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              La passione per il calcio dal 1920. Formiamo campioni sul campo e nella vita.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Link Rapidi</h4>
            <ul className="space-y-2">
              {[
                { path: "/prima-squadra", label: "Prima Squadra" },
                { path: "/giovanili", label: "Settore Giovanile" },
                { path: "/organigramma", label: "Organigramma" },
                { path: "/news", label: "News" },
                { path: "/sponsor", label: "Sponsor" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contatti</h4>
            <p className="text-xs text-[#0EA5E9] font-semibold mb-3">Società Affiliata a Juventus FC</p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 text-[#0EA5E9]" />
                <span>Via Trento 104<br />10088 Volpiano (TO)</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Phone className="w-4 h-4 text-[#0EA5E9]" />
                <span>+39 011 9953082</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Mail className="w-4 h-4 text-[#0EA5E9]" />
                <span>segreteria@gsdvolpiano.it</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-bold text-lg mb-4">Seguici</h4>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/gsdvolpiano/?locale=it_IT"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-[#0047AB] transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/gsdvolpianopianese/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-[#0047AB] transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
            <p className="text-slate-500 text-xs mt-4">
              Rimani aggiornato sulle ultime novità del club
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} G.S.D. Volpiano Pianese. Tutti i diritti riservati.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/safeguarding"
                data-testid="safeguarding-footer"
                className="text-slate-500 hover:text-white text-sm transition-colors flex items-center gap-1"
              >
                <Shield className="w-4 h-4" />
                Safeguarding
              </Link>
              <Link
                to="/admin"
                data-testid="admin-login-footer"
                className="text-slate-500 hover:text-white text-sm transition-colors"
              >
                Area Admin
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
